import { render, staticRenderFns } from "./WorkbenchTable.vue?vue&type=template&id=d742bf60&scoped=true&"
import script from "./WorkbenchTable.vue?vue&type=script&lang=js&"
export * from "./WorkbenchTable.vue?vue&type=script&lang=js&"
import style0 from "./WorkbenchTable.vue?vue&type=style&index=0&id=d742bf60&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d742bf60",
  null
  
)

export default component.exports